import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Switch from 'react-switch'
import { deletePeripheralAction, updateEntityAction } from 'actions/entityActions'
import { peripheralSelector } from 'selectors/components'
import { ACCESS_WIRE_TYPES_MAP, ACCESS_TYPE_MAP, READER_PROTOCOL_TYPES, COLORS } from 'helpers/globals'

const Toggle = ({ checked, onChange, disabled, className }) =>
  <Switch
    checked={checked}
    onChange={onChange}
    onColor='#5CA5E4'
    onHandleColor={COLORS.primary}
    handleDiameter={20}
    uncheckedIcon={false}
    checkedIcon={false}
    boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
    activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
    height={13}
    width={32}
    className={className + ' react-switch'}
    disabled={disabled}
  />

function mapStateToProps(state, ownProps) {
  return {
    device: peripheralSelector(state, ownProps)
  }
}

class PeripheralDevice extends React.Component {
  deleteButton = _ => {
    const { peripheralType, peripheralId, doorId, classes, deletePeripheralAction } = this.props

    return (
      <a onClick={_ => deletePeripheralAction(peripheralType, peripheralId, doorId)} className={classes.removeIcon}>
        <FontAwesomeIcon icon={['far', 'trash-alt']} />
      </a>
    )
  }

  handleTypeChange = choice => _ => {
    const { device: { type, customType, wireType }, peripheralType, peripheralId, updateEntityAction } = this.props

    if (choice === type && !customType) return

    let changes = { type: choice }

    if (peripheralType === 'readers') {
      if (choice === 'Biometric') changes['wireType'] = 'Ethernet'
      else if (wireType === 'Ethernet') changes['wireType'] = ACCESS_WIRE_TYPES_MAP['readers'].options[ACCESS_WIRE_TYPES_MAP['readers'].default]
    }

    if (['readers', 'auxiliaryInputs'].includes(peripheralType)) {
      changes['customType'] = false
    }

    updateEntityAction(peripheralType, peripheralId, changes)
  }

  handleOtherClick = _ => {
    const { device: { type, customType, wireType }, peripheralType, peripheralId, updateEntityAction } = this.props

    if (customType) return

    let changes = { customType: true, type: '' }

    if (peripheralType === 'readers' && wireType === 'Ethernet') {
      changes['wireType'] = ACCESS_WIRE_TYPES_MAP['readers'].options[ACCESS_WIRE_TYPES_MAP['readers'].default]
    }

    updateEntityAction(peripheralType, peripheralId, changes)
  }

  handleProtocolChange = choice => _ => {
    const { device: { protocol }, peripheralType, peripheralId, updateEntityAction } = this.props

    if (choice === protocol) return

    let changes = { protocol: choice }
    if (choice === 'OSDP') {
      changes['wireType'] = '22/4'
      changes['wireShielded'] = true
    }

    updateEntityAction(peripheralType, peripheralId, changes)
  }

  render() {
    const { device, peripheralType, peripheralId, updateEntityAction, classes } = this.props

    if (!device) return <div className={classes.subContainer} />

    const { type, wireType, wireShielded, customType } = device

    const deviceTypes = ACCESS_TYPE_MAP[peripheralType]
    const updateDevice = updates => updateEntityAction(peripheralType, peripheralId, updates)
    const firstRow = deviceTypes.length > 0
    const secondRow = peripheralType === 'auxiliaryOutputs'
    const showOther = ['readers', 'auxiliaryInputs'].includes(peripheralType)

    let wireTypes = ACCESS_WIRE_TYPES_MAP[peripheralType].options
    if (peripheralType === 'readers' && !customType && type === 'Biometric') wireTypes = ['Ethernet', '22/6', '22/4']

    return (
      <div className={classes.subContainer}>
        { firstRow &&
          <div className={classes.row}>
            {this.deleteButton()}
            <span>Type:</span>
            { deviceTypes.map(choice =>
                <div
                  onClick={this.handleTypeChange(choice)}
                  className={classes.viewChoice + ((choice === type && !customType) ? ' selected' : '')}
                  key={choice}
                >
                  {choice}
                </div>
              )
            }
            { showOther &&
              <div
                onClick={this.handleOtherClick}
                className={classes.viewChoice + (customType ? ' selected' : '')}
              >
                Other
              </div>
            }
          </div>
        }
        { (secondRow || customType) &&
          <div className={classes.row}>
            {!firstRow && this.deleteButton()}
            {!customType && <span>Type:</span>}
            <input
              type='text'
              onChange={({ target: { value } }) => updateDevice({ type: value })}
              value={type}
              style={{ margin: customType ? '0 0 .75rem 7rem' : 0, flex: 1 }}
            />
          </div>
        }
        { peripheralType === 'readers' &&
          <div className={classes.row}>
            <span>Protocol:</span>
            { READER_PROTOCOL_TYPES.map(choice =>
                <div
                  onClick={this.handleProtocolChange(choice)}
                  className={classes.viewChoice + (choice === device.protocol ? ' selected' : '')}
                  key={choice}
                >
                  {choice}
                </div>
              )
            }
          </div>
        }
        <div className={classes.row}>
          {!firstRow && !secondRow && this.deleteButton()}
          <span>Wire:</span>
          { wireTypes.map(choice =>
              <div
                onClick={_ => choice !== wireType && updateDevice({ wireType: choice })}
                className={classes.viewChoice + (choice === wireType ? ' selected' : '')}
                key={choice}
              >
                {choice}
              </div>
            )
          }
        </div>
        <div className={classes.row}>
          <Toggle
            onChange={wireShielded => updateDevice({ wireShielded })}
            checked={wireShielded}
            className={classes.toggle}
          />
          <span>Shielded?</span>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { deletePeripheralAction, updateEntityAction })(injectSheet(style)(PeripheralDevice))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/PeripheralDevice/index.js